(ns teamoesterreich.text.get-text
  (:require
    [teamoesterreich.view-state :as v-state]
    ))


(defn txt [module key]
  (or (get-in v-state/TEXT_MAP [module key]) (str "??" module "/" key)))


(defn transl [key]
  (let [lang (or js/navigator.language js/navigator.userLanguage "de")
        lang (cond
               ;(re-find lang #"^en.*") "en"
               ;(re-find lang #"^de.*") "de"
               (= lang "en") "en"
               (= lang "en-US") "en"
               (= lang "en-GB") "en"

               (= lang "de") "de"
               (= lang "de-DE") "de"
               (= lang "de-AT") "de"
               :else "de")
        res (or (get-in v-state/TRANSLATION_MAP [lang key])
                (get-in v-state/TEXT_MAP ["de" key])
                (str "??" lang "/" key))

        ]
    (str res)))



;(in-ns 'teamoesterreich.text.get-text)






